/*
 * 入口文件 —— 特规通PC端
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';

import EventBus from '@/bus';
Vue.prototype.$bus = EventBus;

// 导入Vuex存储
import store from './store';

import '@/assets/font/iconfont.css';

// 导入v-org-tree
// import VTree from './VTree';

// 导入图标
import './icons';
import './styles/index.less';
import './styles/fstyle.less';

import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// lz_project 设计系统 — Element UI 全局主题覆盖
import './styles/element-variables.scss';

// 引入mack.js
import '@/mock/index.js';
import VueParticles from 'vue-particles';

// 引入自定义指令
import clickOnce from './directives/clickOnce';
Vue.directive('click-once', clickOnce);
import watermark from './directives/waterMark';
Vue.directive('watermark', watermark);
import nonBlockingDrawer from './directives/nonBlockingDrawer';
Vue.directive('non-blocking-drawer', nonBlockingDrawer);
// import copyImage from './directives/copyImage';
// Vue.directive('copy-image', copyImage);

// 引入font-awesome.css
import 'font-awesome/css/font-awesome.css';

// 共用方法
import PubMix from '@/utils/PubMix.js';

// 字体图标容错自救：预加载 + 失败重试（详见 utils/fontRescue.js）
import { initFontRescue } from '@/utils/fontRescue.js';


Vue.use(VueParticles);

Vue.mixin(PubMix);

Vue.config.productionTip = false;
Vue.use(ElementUI);

// 字体图标预加载与失败自愈（解决发布窗口/弱网下字体 404 后图标永久豆腐块问题）
initFontRescue();

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
